module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<div>\n	<form action="/" method="POST" class="js-login-form" novalidate>\n\n		<label for="login-email">Enter Email</label>\n		<input type="email" id="login-email" class="js-email">\n\n		<label for="login-password">Enter Password</label>\n		<input type="password" id="login-password" class="js-password">\n\n		<input type="submit" formmethod="post" class="hidden">\n\n		<br>\n\n		<input class="js-login" type="submit" value="LOGIN">\n	</form>\n\n	<div class="js-error-form hidden">\n		Please enter email and password\n	</div>\n</div>';
}
return __p;
};
